import Controller from '@ember/controller';
import { getOwner } from '@ember/application';
import { computed } from '@ember/object';

/**
 * This controller handles printing out all the top level paths in Ember.  The purpose of this is to be
 * a dev only file that will easily print the files that need to be updated in ember-routes.json.
 * You should hit this page in dev mode and copy/paste to update the files in ember-routes.json.
 */
class AllRoutesController extends Controller {
  /**
   * List of all the routes on our Ember app.
   *
   * @type {Ember.MutableArray<String>}
   */
  get _allRoutes() {
    const router = getOwner(this).lookup('router:main');
    const allRoutesList = router.router.recognizer.names;
    const routeNames = Object.keys(allRoutesList);
    const routeMap = {};

    routeNames.forEach((routeName) => {
      let path = '';
      try {
        path = router.generate(routeName);
      } catch (e) {
        //gobble
        return;
      }

      if (!path) {
        return;
      }

      const routeParts = path.split('/');
      const routeFirstPrefix = routeParts[1];
      if (!routeFirstPrefix || /_unused_/.test(routeFirstPrefix) || /_loading/.test(routeFirstPrefix)) {
        //These are potentially internal routes that ember will attach to the route names that aren't actually navigable
        //by normal users.
        return;
      }

      routeMap[routeFirstPrefix] = true;
    });

    return Object.keys(routeMap);
  }

  /**
   * @type {Number}   The last index of the allRoutes array.
   */
  @computed('_allRoutes.[]')
  get _allRoutesLastIndex() {
    return this._allRoutes.length - 1;
  }
}

export default AllRoutesController;
